import { useEffect, useState } from "react";
import { api, fmtAZN } from "@/lib/api";

export const WagerInfo = ({ info }) => {
  const [st, setSt] = useState(null);
  useEffect(() => { api.get("/wallet/status").then(({ data }) => setSt(data)); }, []);
  if (!st) return null;
  const pct = st.wager_required ? Math.min(100, (st.wagered / st.wager_required) * 100) : 100;
  const done = st.wagered >= st.wager_required;
  return (
    <div className="rounded-2xl bg-black/40 border border-white/10 p-5 space-y-4 text-sm" data-testid="wager-info">
      <div>
        <div className="flex justify-between mb-2">
          <span className="text-zinc-400">Dövriyyə (depozitin 1 qatı)</span>
          <span className={done ? "text-emerald-400" : "text-[#FFD700]"} data-testid="wager-progress">{fmtAZN(Math.min(st.wagered, st.wager_required))} / {fmtAZN(st.wager_required)}</span>
        </div>
        <div className="h-2 rounded-full bg-white/10 overflow-hidden"><div className={`h-full ${done ? "bg-emerald-500" : "btn-gold"}`} style={{ width: `${pct}%` }} /></div>
        {!done && <p className="text-xs text-zinc-500 mt-2">Çıxarış üçün yatırdığınız məbləği ən azı 1 dəfə real rejimdə oynamalısınız.</p>}
      </div>
      <div className="flex justify-between text-zinc-400">
        <span>Bugünkü çıxarışlar</span>
        <span data-testid="withdraws-today">{st.withdraws_today} / {st.daily_withdraws}</span>
      </div>
      <div className="flex justify-between text-zinc-400"><span>Limit</span><span>{info.min_withdraw} – {info.max_withdraw} ₼</span></div>
    </div>
  );
};
